/* unplugin-vue-components disabled */import script from "./ComplaintsWidgetMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComplaintsWidgetMain.vue?vue&type=script&setup=true&lang=ts"

import "./ComplaintsWidgetMain.vue?vue&type=style&index=0&id=6398719e&lang=scss"

const __exports__ = script;

export default __exports__